import type { MEATBALL_MENU_APPEARANCE, CONTEXT_MENU_APPEARANCE } from '../common/constants.tsx';

export const makeScope = (
	scope: string,
	menuType: typeof CONTEXT_MENU_APPEARANCE | typeof MEATBALL_MENU_APPEARANCE,
) => `${scope}-${menuType}`;
